
import React from 'react';
import GeneralSettingsTab from './GeneralSettingsTab';

const MasterLicenseGeneralSettingsTab: React.FC = () => {
  return <GeneralSettingsTab />;
};

export default MasterLicenseGeneralSettingsTab;
